export default {
  methods: {
    render_rightDialog(data) {
      let leftChart = [];
      leftChart = data.saleNumProportion.map(v=>{
        return {
          value: v.proportion,
          name: v.category
        }
      })
      let rightChart = data.categoryProportion.map(v=>{
        return {
          value: v.proportion,
          name: v.category
        }
      })
      rightChart.unshift({ value: null,name: '\n'}) //在第一个添加全选
      rightChart.unshift({ value: null,name: '全选'}) //在第一个添加全选

      let rightName = rightChart.reduce((obj, cur, index) => {
        obj[`${cur["name"]}`] = true;
        return obj;
      }, {});
      let length = leftChart.length + rightChart.length -2
      let colorArr = this.getColorRandom(length).splice(-rightChart.length)
      console.log(colorArr);
      let option = {
        color: colorArr,
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross',
            crossStyle: {
                color: '#999'
            }
        },
        formatter: params => {
          const index = params.componentIndex;
          let indexOf = ['categoryProportion']
          let name = indexOf[index]
          let str = "";
          let arr = data[name][params.dataIndex-2] //新增了全选和换行 索引需-2
          str = `${params.marker}${params.name}<br/>产品数<span style="inline-block; width:50px; text-algin:right; float:right; font-weight:800; margin-left: 20px;">${arr.productCount||0}</span><br/>占比<span style="inline-block; width:50px; font-weight:800; text-algin:right; float:right; margin-left: 20px;">${arr.proportion + '%'||0}</span><br/>`
          return  str
        },
        },
        legend: 
          // {
          //   top: 10,
          //   right: 10,
          //   left: 10,
          //   data: leftChart.map(v=>v.name)
          // },
          {
            top: 0,
            right: 10,
            left: 10,
            data: rightChart.map(v=>v.name),
            selected: rightName,
          },
        series: [
          // {
          //   // name: 'Access From',
          //   type: 'pie',
          //   radius: ['45%', '30%'],
          //   center: ['25%', '76%'],
          //   minAngle: 5,  //设置扇形的最小占比
          //   label: {
          //     show: false,
          //     position: 'center'
          //   },
          //   labelLine: {
          //     show: false
          //   },
          //   data: leftChart
          // },
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['55%', '0%'],
            center: ['50%', '70%'],
            minAngle: 5,  //设置扇形的最小占比
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: rightChart
          }
        ]
      };
      let $instance = this.$echarts.init(this.$refs['rightDialog']);
      $instance.setOption(option);
      $instance.on('legendselectchanged',function(obj){
        console.log(option);
        if(obj.selected['全选'] && obj.name == '全选') {
          Object.keys(option.legend.selected).forEach(key => {
            option.legend.selected[key] = true
          });
          $instance.setOption(option);
        }else if(!obj.selected['全选'] && obj.name == '全选') {
          Object.keys(option.legend.selected).forEach(key => {
            option.legend.selected[key] = false
          });
          $instance.setOption(option);
        }
      })
    }
  }
}